/* global serverParams */

import { loadTable } from '../table'

import selected from './selected'

const placeholder_html = `
<div class="stats-holder">
    <div class="stat-holder-row">
        <div class="total-pitches stat-holder" data-scale="density">
            <div class="stat-value"></div>
            <div class="stat-title">Block Opportunities</div>
        </div>
        <div class="actual-expected stat-holder" data-scale="exp_pbwp_added">
            <div class="stat-value"></div>
            <div class="stat-title">Blocks Above Avg</div>
        </div>
    </div>
    <div class="stat-holder-row">
        <div class="pbwp stat-holder" data-scale="total">
            <div class="stat-value"></div>
            <div class="stat-title">Actual PB&nbsp;+&nbsp;WP</div>
        </div>
        <div class="x-pbwp stat-holder" data-scale="exp_pbwp">
            <div class="stat-value"></div>
            <div class="stat-title">Estimated PB&nbsp;+&nbsp;WP</div>
        </div>
    </div>
</div>
`
function createResultwrapper() {
    const $result = document.createElement('div')
    $result.classList.add('search-result')

    return $result
}

export function createSearchElement(datum) {
    const { is_team_type } = serverParams

    const $result = createResultwrapper()

    $result.dataset.id = datum.entity_id
    $result.dataset.team = datum.key_team_id
    $result.dataset.year = datum.start_year

    const val =
        datum.diff_runner_pbwp >= 0
            ? `+${datum.diff_runner_pbwp.toFixed(1)}`
            : datum.diff_runner_pbwp.toFixed(1)

    const $team = `<span style="display: inline-flex; justify-content: center; align-items: center; padding: 2px; background: #fff; border-radius: 23%; height: 24px; width: 24px; margin: 0 8px;"><img height="18" width="18" style="width: auto; max-width: 20px; border-radius: 0;" src="${datum.team_image_url}" /></span>`

    const $years = serverParams.splitYears
        ? `<span style="font-size: 12px">${datum.start_year}</span>`
        : ''

    const image = is_team_type
        ? ''
        : `<img src="https://content.mlb.com/images/headshots/current/60x60/${datum.entity_id}.png" height="30" />`

    $result.innerHTML = `
    <div class="search-result-header">
        <div class="search-result-name-image">
            <div class="search-result-image">
                ${image}
            </div>
            <div class="search-result-name">
                ${datum.entity_name}${$team}${$years}
            </div>
        </div>
        <svg class="hide spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="12" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
        <div class="search-result-value ${
            datum.diff_runner_pbwp < 0 ? 'negative-value' : ''
        }">${val}</div>
        <div class="search-result-remove glyphicon glyphicon-remove"></div>
    </div>
    ${placeholder_html}`

    return $result
}

function createBlankResult(text = 'No Results Found') {
    const $result = createResultwrapper()
    $result.innerText = text
    $result.classList.add('search-result-blank-text')

    return $result
}

function removeSpinner($result) {
    // hide spinner
    $result.querySelector('.spinner').classList.add('hide')
}

export default class SearchHandler {
    constructor($input, $search_wrapper, $legend, data, callback) {
        this.$input = $input
        this.$search_wrapper = $search_wrapper
        this.$legend = $legend
        this.data = data
        this.callback = callback

        this.addListener()
        this.addClickHandler()
    }

    addListener() {
        this.$input.addEventListener('input', (e) => {
            // Clear current results
            this.$search_wrapper.innerHTML = ''
            this.$search_wrapper.style.display = 'block'

            if (selected.players.length === 6) {
                this.$search_wrapper.appendChild(
                    createBlankResult('Max 6 Catchers')
                )
                this.$search_wrapper.appendChild(
                    createBlankResult('Remove a catcher before adding.')
                )
                return
            }
            const filtered = this.getFilteredData(e.target.value)

            loadTable(filtered)

            const filtered_num = filtered.length === 5 ? 5 : 4
            const filtered_sliced = filtered.slice(0, filtered_num)

            // Clear current results
            this.$search_wrapper.innerHTML = ''
            this.$search_wrapper.style.display = 'block'

            // Add new results
            filtered_sliced.forEach((d) => {
                const $result = createSearchElement(d)
                this.$search_wrapper.appendChild($result)
            })

            if (!filtered.length) {
                this.$search_wrapper.appendChild(createBlankResult())
            } else if (filtered_sliced.length !== filtered.length) {
                this.$search_wrapper.appendChild(
                    createBlankResult(
                        `+ ${
                            filtered.length - filtered_sliced.length
                        } More Results`
                    )
                )
            }
        })
    }

    getFilteredData(search) {
        const normalized_search = search
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return this.data
            .filter((d) => {
                const catcher_name = d.entity_name
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase()

                return catcher_name.includes(normalized_search)
                // && !selected.includes(d)
            })
            .sort((a, b) => b.diff_runner_pbwp - a.diff_runner_pbwp)
    }

    addClickHandler() {
        this.$search_wrapper.addEventListener('click', async (e) => {
            if (selected.raw_data.length >= 6) {
                return
            }

            const $result = e.target.closest('.search-result')
            if ($result && $result?.dataset?.id) {
                this.moveResult($result)

                // Yikes this is hairy
                await this.callback({
                    entity_id: Number($result.dataset.id),
                    start_year: Number($result.dataset.year),
                    key_team_id: $result.dataset.team,
                })

                removeSpinner($result)
            }
        })
    }

    moveResult($result) {
        // remove from search results
        $result.remove()
        // add to legend with wrapper
        this.$legend.appendChild($result)

        // show spinner
        $result.querySelector('.spinner').classList.remove('hide')

        // hide +/- blocks
        $result.querySelector('.search-result-value').classList.add('hide')
    }
}
